import React, { useEffect, useState } from 'react';
import { globals } from '../../misc/globals';
import { playSound } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

import './GeneralButton.css'

const GeneralButton = (props: UIProperties<GeneralButtonConfig>) => {
	const [isOver, setIsOver] = useState(false);
	const [forceHighlight, setforceHighlight] = useState(false);
    if(props.parameters.onForceHighlight) {
        props.parameters.onForceHighlight((shouldForce: boolean) => {
            setforceHighlight(shouldForce);
        });
    }
    
	useEffect(() => {

	}, [isOver])

	return (
		<div className='modal-disable-select' style={{
			position: 'absolute',
			top: props.parameters.top,
			left: props.parameters.left,
			right: props.parameters.right,
			width: props.parameters.width
		}}>
			<button className="pointer" tabIndex={props.parameters.NotTabbable || props.parameters.isDisabled ? -1 : 0} aria-label={props.parameters.ariaLbl} id={props.parameters.id} style={{
				position: 'relative',
				background: 'transparent',
				pointerEvents: props.parameters.isDisabled ? 'none' : 'all',
				...props.parameters.customBttnStyle
            }} 
			aria-disabled={props.parameters.isDisabled}
			onMouseOver={() => {
                if(props.parameters.highlightOnHover) {
                    setIsOver(true);
                }
			}} onMouseEnter={() => {
				if(props.parameters.ariaLbl === 'Exit Game') {
					playSound('./assets/audio/Patient_Menu_Rollover');
				} else {
					var rollOverAudio = document.getElementById('button-rollover');
					if(!globals.isMuted) {
						(rollOverAudio as any).play();
					}
				}
				
			}} onMouseDown={() => {
				setIsOver(true);
			}} onMouseUp={() => {
				setIsOver(false);
			}} onMouseOut={() => {
				setIsOver(false);
			}} onClick={() => {
				if(props.parameters.isDisabled) {
					return;
				}
				
				if(props.parameters.ariaLbl === 'Exit Game') {
					playSound('./assets/audio/Patient_Menu_Click');
				} else {
					var clickAudio = document.getElementById('button-click');
					if(!globals.isMuted) {
						(clickAudio as any).play();
					}
				}
				
				if(props.parameters.onClicked) {
					props.parameters.onClicked();
				}
			}}>
				<img style={{
					pointerEvents: 'none',
					filter: props.parameters.isDisabled ? 'brightness(50%)' : 'brightness(100%)',
					...props.parameters.customImgStyle
				}} src={props.parameters.srcIdle} />
				{isOver || props.parameters.shouldLeaveOn || forceHighlight ? (<img style={{
					position: 'absolute',
					top: '0',
					left: '0',
					width: '100%',
					height: '100%',
					pointerEvents: 'none',
					...props.parameters.customImgStyle
				}} src={props.parameters.srcHighlight} />) : (<div></div>)}
				{props.parameters.isDisabled && props.parameters.srcDisabled ? (<img style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'none',
					...props.parameters.customImgStyle
                }} src={props.parameters.srcDisabled} />) : (<div></div>)}
			</button>
		</div>
	);

};

export interface GeneralButtonConfig extends BaseConfig{
	srcIdle: string;
	srcHighlight: string;
	srcDisabled?: string;
    isDisabled?: boolean;
	ariaLbl?: string;
	NotTabbable?: boolean;
	id?: string;
	top: string;
	left?: string;
	right?: string;
	width: string;
	shouldLeaveOn?: boolean;
	highlightOnHover?: boolean;
	customImgStyle?: any;
	customBttnStyle?: any;
	onClicked: () => void;
	onForceHighlight?: (forceHighlight: (shouldForce: boolean) => void) => void;
}

export default GeneralButton;